import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { arrayHas } from "../../../utils/arrayHas.js";
import { createAction } from "../../../r-html/dist/store/index.js";
import { invalidateTableIndexes } from "../../../utils/tableKeys.js";
import { ActionType } from "./actions.js";
import { createIndex } from "../../../utils/collection/index.entity.js";
//#region src/engine/modules/index/atom.actions.ts
var addIndexAction = createAction(ActionType.addIndex);
var addIndex = ({ doc, collections, lww }, { payload: { id, tableId }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	query(collections).collection("indexEntities").addOne(createIndex({
		id,
		tableId
	})).addOperator(lww, safeVersion, id, () => {
		if (!arrayHas(doc.indexIds)(id)) {
			doc.indexIds.push(id);
			invalidateTableIndexes();
		}
	});
};
var removeIndexAction = createAction(ActionType.removeIndex);
var removeIndex = ({ doc, collections, lww }, { payload: { id }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	query(collections).collection("indexEntities").removeOperator(lww, safeVersion, id, () => {
		const index = doc.indexIds.indexOf(id);
		if (index !== -1) {
			doc.indexIds.splice(index, 1);
			invalidateTableIndexes();
		}
	});
};
var changeIndexNameAction = createAction(ActionType.changeIndexName);
var changeIndexName = ({ collections, lww }, { payload: { id, tableId, value }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("indexEntities");
	collection.getOrCreate(id, (id) => createIndex({
		id,
		tableId
	}));
	collection.replaceOperator(lww, safeVersion, id, "name", () => {
		collection.updateOne(id, (index) => {
			index.name = value;
		});
	});
};
var changeIndexUniqueAction = createAction(ActionType.changeIndexUnique);
var changeIndexUnique = ({ collections, lww }, { payload: { id, tableId, value }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("indexEntities");
	collection.getOrCreate(id, (id) => createIndex({
		id,
		tableId
	}));
	collection.replaceOperator(lww, safeVersion, id, "unique", () => {
		collection.updateOne(id, (index) => {
			index.unique = value;
		});
	});
};
var indexReducers = {
	[ActionType.addIndex]: addIndex,
	[ActionType.removeIndex]: removeIndex,
	[ActionType.changeIndexName]: changeIndexName,
	[ActionType.changeIndexUnique]: changeIndexUnique
};
var actions = {
	addIndexAction,
	removeIndexAction,
	changeIndexNameAction,
	changeIndexUniqueAction
};
//#endregion
export { actions, addIndexAction, changeIndexNameAction, changeIndexUniqueAction, indexReducers, removeIndexAction };
